<template>
  <div class="indexBg">
    <div class="enterprise-ai-container">
      <!-- 顶部通知栏 -->
      <div class="top-notice">🎉 企联AI入选奇绩创坛 F23 创业营，加速重构生产环境下人与AI协同关系</div>
      <!-- 主内容区 -->
      <div class="divCss main-content">
        <div class="topImg">
          <img class="left-logo" src="@/assets/logo.png"/>
          <div style="display: flex;align-items: center">
            <img class="right-github" src="@/assets/github.png" alt="GitHub" />
            <div class="more-service">
              <span>更多服务<i class="el-icon-arrow-down"></i></span>
              <!-- 下拉菜单 -->
              <div class="service-dropdown">
                <a target="_blank" href="https://www.nyackuajing.com/">综合平台</a>
                <a target="_blank" href="https://wm.nyackuajing.com/">跨境出海</a>
                <a target="_blank" href="https://catweb.nyackuajing.com/">猫猫译站</a>
                <a target="_blank" href="http://ai.nyackuajing.com/">AI智能</a>
                <a target="_blank" href="http://acxy.nyackuajing.com/">人才培育</a>
              </div>
            </div>
          </div>
        </div>
        <!-- 中间标签 -->
        <div class="middle-tag animate-trigger" data-animate="fadeInUp" data-delay="0">AI 轻客服上线啦！<span>→</span></div>
        <!-- 标题和描述 -->
        <div class="title-desc">
          <h1 class="main-title animate-trigger" data-animate="fadeInUp" data-delay="100">企联AI</h1>
          <p class="main-desc animate-trigger" data-animate="fadeInUp" data-delay="200">
            企业级协同AI平台，基于飞书等协作工具，赋能企业中的每一位员工。<br />
            自主管理AI资产，无忧接入海量行业场景应用。
          </p>
        </div>
        <!-- 功能按钮 -->
        <div class="function-btns animate-trigger" data-animate="fadeInUp" data-delay="300">
          <button class="btn ai-market">AI 应用市场 <span>→</span></button>
          <button class="btn online-experience"><img src="@/assets/icon1.png"/>在线体验</button>
          <button class="btn contact-service"><img src="@/assets/icon2.png"/>联系客服</button>
        </div>
      </div>
      <!-- 合作品牌区 -->
      <div class="divCss brandsDiv">
        <div class="brands-container">
          <!-- 滚动轨道：用于动画平移 -->
          <div class="brands-track">
            <!-- 品牌列表（复制一份用于无缝滚动） -->
            <div class="cooperation-brands" v-for="item in 2">
              <img src="@/assets/icon3.png" alt="袋鼠先生" />
              <img src="@/assets/icon4.png" alt="完美日记" />
              <img src="@/assets/icon5.png" alt="驭势科技" />
              <img src="@/assets/icon6.png" alt="辰木互动" />
              <img src="@/assets/icon7.png" alt="辰木互动" />
              <img src="@/assets/icon8.png" alt="辰木互动" />
              <img src="@/assets/icon9.png" alt="辰木互动" />
              <img src="@/assets/icon10.png" alt="辰木互动" />
            </div>
          </div>
        </div>
      </div>
      <div class="divCss ai-platform-section">
        <div class="left-content animate-trigger" data-animate="fadeInUp" data-delay="200">
          <p class="section-tag">通用 AI 集成平台</p>
          <h2 class="section-title">企联 AI 赋能每一位员工</h2>
          <p class="section-desc">快速接入通用AI能力，提升企业生产效率</p>
          <div class="ai-list">
            <div class="ai-item active"><i class="icon-feishu"></i>飞书-AIGC</div>
            <div class="ai-item"><i class="icon-feishu"></i>飞书-Midjourney</div>
            <div class="ai-item"><i class="icon-feishu"></i>飞书-StableDiffusion</div>
          </div>
        </div>
        <div class="right-visual">
          <div class="grid-bg"></div>
          <div class="ai-icon">
            <img src="@/assets/ai2.png" alt="AI 图标" />
          </div>
        </div>
      </div>
      <div class="divCss threeDiv">
        <div class="titCss animate-trigger" data-animate="fadeInUp" data-delay="200">
          <h1>企联AI产品矩阵</h1>
          <p>帮助企业快速了解 AI 产品，快速选型，快速落地，快速实现商业价值</p>
        </div>
        <div class="tItem threeTop animate-trigger" data-animate="fadeInUp" data-delay="200">
          <div class="threeText">
            <h3>企联AI数据中心</h3>
            <p>AI 资源接入、企业知识库、应用日志、风险规避和权限配额 ......<br />全面掌控公司的AI应用，避免敏感信息泄露和意外风险的发生</p>
          </div>
          <img src="@/assets/jz1.png" />
        </div>
        <div class="threeBottom animate-trigger" data-animate="fadeInUp" data-delay="200">
          <div class="tItem threeItem" style="margin-right:0.25rem">
            <div class="threeText">
              <h3>Connect AI Flow</h3>
              <p>拖拽即可创建强大的AI工作流，自动化生产任务</p>
            </div>
            <img src="@/assets/jz2.png" />
          </div>
          <div class="tItem threeItem">
            <div class="threeText">
              <h3>开源社区</h3>
              <p>团队成员孵化于开源社区，共享出大量通用AI解决方案。</p>
            </div>
            <img src="@/assets/jz3.png" />
          </div>
        </div>
        <div class="descDiv animate-trigger" data-animate="fadeInUp" data-delay="200">
          <div class="descItem" v-for="item in textArr">
            <p class="descTit"><img :src="item.img" />{{ item.tit }}</p>
            <div>{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="divCss fourDiv">
        <div class="titCss animate-trigger" data-animate="fadeInUp" data-delay="200">
          <h1>兼容多款办公平台</h1>
          <p>无论国内还是国外，企联AI都能提供安心的AI集成解决方案</p>
        </div>
        <img class="animate-trigger" data-animate="fadeInUp" data-delay="200" src="@/assets/icon11.png" />
      </div>
      <div class="divCss fiveDiv">
        <div class="titCss animate-trigger" data-animate="fadeInUp" data-delay="200">
          <h1>应用商店</h1>
          <p>开箱即用的海量AI应用, 快速赋能企业里的每一位员工</p>
        </div>
        <div class="ai-feature-section animate-trigger" data-animate="fadeInUp" data-delay="200">
          <div class="feature-card" v-for="(item, index) in featureList" :key="index">
            <img class="card-icon" :src="item.icon" />
            <h3 class="card-title">{{ item.title }}</h3>
            <p class="card-desc">{{ item.desc }}</p>
            <a href="#" class="card-link">了解更多 <span>→</span></a>
          </div>
        </div>
        <div class="card-nav">
          <button class="nav-btn" @click="scrollLeft">&lt;</button>
          <button class="nav-btn" @click="scrollRight">&gt;</button>
        </div>
      </div>
      <div class="divCss sixDiv">
        <div class="titCss animate-trigger" data-animate="fadeInUp" data-delay="200">
          <h1>场景应用快速体验</h1>
          <p>企联AI与行业头部企业携手共创，探索一系列企业生产场景AI赋能</p>
        </div>
        <div class="chat-feature-section animate-trigger" data-animate="fadeInUp" data-delay="200">
          <div class="section-group">
            <h3 class="section-title">Chat HR</h3>
            <div class="feature-row">
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a1.png" />AI简历管理</h4>
                <p class="item-desc">支持将公司的简历数据向量化存储，轻松管理公司简历库，以通过AI进行对话，精准获取对应简历</p>
              </div>
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a2.png" />AI面试出题</h4>
                <p class="item-desc">可根据岗位JD和简历信息，便捷生成对应的定制面试题，精准识别求职者</p>
              </div>
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a3.png" />HR模拟培训</h4>
                <p class="item-desc">根据岗位JD生成模拟面试角色，帮助新人HR模拟面试，提升成长</p>
              </div>
            </div>
          </div>
          <div class="section-divider"></div>
          <div class="section-group">
            <h3 class="section-title">Chat SALE</h3>
            <div class="feature-row">
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a4.png" />产品知识库</h4>
                <p class="item-desc">支持将公司的产品知识库、销售话术技巧等数据向量化存储，针对问答，在提供答案外，能够展示答案所属的商品/文件，方便进一步查看</p>
              </div>
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a5.png" />客户回复</h4>
                <p class="item-desc">将客户的回复(邮件/产品评论转到AI，机器人可以快速给出话术/邮件/评论回复建议</p>
              </div>
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a6.png" />销售培训</h4>
                <p class="item-desc">扮演不同的客户及场景角色，模拟销售与客户沟通场景，帮助新手销售快速成长</p>
              </div>
            </div>
          </div>
          <div class="section-divider"></div>
          <div class="section-group">
            <h3 class="section-title">Chat OFFICE</h3>
            <div class="feature-row">
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a7.png" />Excel助手</h4>
                <p class="item-desc">通过语言描述即可自动转换成EXCEL中的公式</p>
              </div>
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a8.png" />PDF助手</h4>
                <p class="item-desc">通过自然语言对话的方式向机器人围绕PDF进行对话沟通，支持PDF内容总结，内容查询等</p>
              </div>
              <div class="feature-item">
                <h4 class="item-title"><img class="item-icon" src="@/assets/a9.png" />文档助手</h4>
                <p class="item-desc">可通过自然语言描述，帮助完成制度文档的撰写、活动宣传语的撰写、测试文档的撰写</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="divCss sevenDiv">
        <div class="titCss animate-trigger" data-animate="fadeInUp" data-delay="200">
          <h1>借助企联 AI 给成员赋能</h1>
          <p>根据需要选择适合的解决方案</p>
        </div>
        <div class="pricing-section animate-trigger" data-animate="fadeInUp" data-delay="200">
          <div class="pricing-grid">

            <!-- 体验版（左侧列） -->
            <div class="col">
              <div class="plan-card trial-card">
                <div class="sevenHead">
                  <!-- 切换按钮 -->
                  <div class="toggle-group">
                    <span>按季</span>
                    <label class="toggle-switch">
                      <input type="checkbox" v-model="isAnnual" />
                      <span class="slider" :class="{ 'annual': isAnnual }"></span>
                    </label>
                    <span :class="{ 'discount': isAnnual }">按年(-20%)</span>
                  </div>
                  <h3>体验版</h3>
                  <p class="sevenText">七天免费试用</p>
                  <button class="deploy-btn">立即部署 →</button>
                </div>
                <!-- 功能列表 -->
                <div class="feature-group">
                  <h4>功能</h4>
                  <ul>
                    <li>自有 AI 资源接入</li>
                    <li>AI 应用接入</li>
                    <li>AI 交互日志</li>
                    <li>应用提示词</li>
                    <li>内部知识库</li>
                  </ul>
                  <h4>产品</h4>
                  <ul>
                    <li>通用 AI 机器人</li>
                    <li>行业场景机器人</li>
                    <li>低代码 AI 工作流</li>
                    <li>AI 插件生态</li>
                    <li>开源模型自部署</li>
                    <li>AI 场景定制</li>
                    <li>权限管理</li>
                  </ul>
                  <h4>售后服务</h4>
                  <ul>
                    <li>一对一服务支持</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- 套餐卡片（右侧三列） -->
            <div class="rigDiv col" style="border-radius: 0.2rem 0 0 0.2rem;">
              <div class="plan-card startup">
                <div class="sevenHead">
                  <h3>初创企业版</h3>
                  <div class="sevenPri">
                    <p class="price">¥<span>{{ isAnnual ? 1599 : 1999 }}</span></p>
                    <p class="original-price" v-if="!isAnnual">原价: ¥2499</p>
                  </div>
                  <p class="member">1年, 10成员</p>
                  <button class="deploy-btn gray">立即部署 →</button>
                </div>
                <div class="feature-group">
                  <h4></h4>
                  <ul>
                    <li>✓</li>
                    <li>✓ 20</li>
                    <li>✓ 100k</li>
                    <li>✓ 1k</li>
                    <li>✓ 30G</li>
                  </ul>
                  <h4></h4>
                  <ul>
                    <li>✓</li>
                    <li>✓</li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li>✓</li>
                  </ul>
                  <h4></h4>
                  <ul>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="rigDiv col">
              <div class="plan-card business highlighted">
                <div class="sevenHead">
                  <h3>中小企业版</h3>
                  <div style="display: flex; align-items: center;">
                    <p class="price">¥<span>{{ isAnnual ? 3599 : 4499 }}</span></p>
                    <p class="original-price" v-if="!isAnnual">原价: ¥5999</p>
                  </div>
                  <p class="member">1年, 30成员</p>
                  <button class="deploy-btn">立即部署 →</button>
                </div>
                <div class="feature-group">
                  <h4></h4>
                  <ul>
                    <li>✓</li>
                    <li>✓ 20</li>
                    <li>✓ 100k</li>
                    <li>✓ 1k</li>
                    <li>✓ 30G</li>
                  </ul>
                  <h4></h4>
                  <ul>
                    <li>✓</li>
                    <li>✓</li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li>✓</li>
                  </ul>
                  <h4></h4>
                  <ul>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="rigDiv col">
              <div class="plan-card private">
                <div class="sevenHead">
                  <h3>私有部署</h3>
                  <p class="price"><span>联系我们</span></p>
                  <p class="member">沟通获取解决方案</p>
                  <button class="deploy-btn gray">立即部署 →</button>
                </div>
                <div class="feature-group">
                  <h4></h4>
                  <ul>
                    <li>✓</li>
                    <li>✓ 20</li>
                    <li>✓ 100k</li>
                    <li>✓ 1k</li>
                    <li>✓ 30G</li>
                  </ul>
                  <h4></h4>
                  <ul>
                    <li>✓</li>
                    <li>✓</li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li>✓</li>
                  </ul>
                  <h4></h4>
                  <ul>
                    <li></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="divCss eight">
        <div class="hero-content animate-trigger" data-animate="fadeInUp" data-delay="100">
          <p class="tagline">让AI赋能你的团队</p>
          <h1 class="title">企联 AI 共创计划正式开启</h1>
          <p class="desc">企业级协同AI平台，基于飞书等协作工具，赋能企业中的每一位员工。自主管理AI资产，无忧接入海量行业场景应用。</p>
          <button class="deploy-btn">立即部署 →</button>
        </div>
      </div>
      <div class="footeDiv">
        <div class="topImg">
          <img class="left-logo" src="@/assets/logo.png"/>
          <p>技术支持由诺语安创提供</p>
        </div>
        <a class="footText" href="https://beian.miit.gov.cn/" target="_blank">备案号： 豫ICP备2024088074号</a>
        <p>服务电话：400-991-3116</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      isMobile: false,// 移动端菜单控制
      showMobileMenu: false,
      aiMarketUrl: '#ai-market',
      onlineExperienceUrl: '#online-experience',
      contactServiceUrl: '#contact-service',
      textArr:[
        {id:1,tit:'AI资源平台',img:require('@/assets/i1.png'),desc:'一键关联文心一言、通义千问、MiniMax、Midjourney、StableDiffusion等海量AI资源'},
        {id:2,tit:'AI应用市场',img:require('@/assets/i2.png'),desc:'基于行业-职能的AI应用矩阵为企业高效赋能'},
        {id:3,tit:'提示词市场',img:require('@/assets/i3.png'),desc:'场景即服务,让您的AI角色更加精准地理解需求'},
        {id:4,tit:'企业知识库',img:require('@/assets/i4.png'),desc:'导入企业文档数据，让AI的回答更贴近企业的业务需求'},
        {id:5,tit:'AI交互日志',img:require('@/assets/i5.png'),desc:'针对性管理企业成员与AI的交互日志，以避免敏感信息泄露和潜在的意外风险'},
        {id:6,tit:'Connect AI Flow',img:require('@/assets/i6.png'),desc:'无需编程，只需拖拽即可创建强大的AI工作流。'},
      ],
      currentPage: 0,
      featureList: [
        {title: '飞书-AIGC',desc: '飞书 × (AI + DALL·E + Whisper) = 飞一般的工作体验',icon: require('@/assets/i7.png')},
        {title: '飞书-文心一言',desc: '飞书 × 百度文心AI = 点亮灵感，进入国内模型的心流体验',icon: require('@/assets/i8.png')},
        {title: '飞书-StableDiffusion',desc: '飞书 × AIGC StableDiffusion = 一键生成高质量商业图片',icon: require('@/assets/i9.png')},
        {title: '飞书-Midjourney',desc: '飞书 x midjourney = 新媒体运营的创意利器',icon: require('@/assets/i10.png')},
        {title: '钉钉-AIGC',desc: '钉钉 & AI 让你的工作效率直接起飞',icon: require('@/assets/i7.png')},
      ],
      isAnnual: false // 控制按年/按季切换
    }
  },
  mounted() {
    this.scrollHandler = () => {// 监听滚动事件（简化防抖）
      requestAnimationFrame(this.checkAnimate); // 用requestAnimationFrame优化性能
    };
    window.addEventListener('scroll', this.scrollHandler);
    this.checkAnimate(); // 初始检查
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  created() {
    this.setRemUnit()// 初始化
    window.addEventListener('resize', this.setRemUnit)// 监听窗口变化
  },
  destroyed() {
    window.removeEventListener('resize', this.setRemUnit); // 移除rem监听
  },
  methods:{
    scrollLeft() {
      const container = this.$el.querySelector('.ai-feature-section');
      container.scrollBy({ left: -320, behavior: 'smooth' });
    },
    scrollRight() {
      const container = this.$el.querySelector('.ai-feature-section');
      container.scrollBy({ left: 320, behavior: 'smooth' });
    },
    setRemUnit() {
      const designWidth = 1920; // 设计稿宽度（按你项目实际设计稿来）
      // 获取当前设备宽度（兼容各种浏览器）
      const deviceWidth = document.documentElement.clientWidth || window.innerWidth || document.body.clientWidth;
      // 限制最小基准值：屏幕宽度小于768px时，按768px计算（避免移动端元素过小）
      // const minDeviceWidth = 768;
      const minDeviceWidth = 300;
      const finalWidth = Math.max(deviceWidth, minDeviceWidth);
      // 计算rem基准值：1rem = 设计稿的100px（方便换算，如设计稿200px → 代码写2rem）
      const remBase = (finalWidth / designWidth) * 100;
      // 设置html的font-size（rem基准值）
      document.documentElement.style.fontSize = `${remBase}px`;
    },
    checkAnimate() {// 检查并激活动画
      document.querySelectorAll('.animate-trigger:not(.animate-active)').forEach(el => {
        const rect = el.getBoundingClientRect();
        // 元素进入视口（底部>0 且 顶部<视口高度）
        if (rect.bottom > 0 && rect.top < window.innerHeight * 0.85) {
          // 新增：获取 data-delay 值，设置到 CSS 变量
          const delay = el.getAttribute('data-delay') || 0;
          el.style.setProperty('--delay', `${delay}ms`);
          // 激活动画
          el.classList.add('animate-active');
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.indexBg {
  font-size:0.2rem;
  color: #ebebeb;
}
.divCss{
  padding:0.7rem 3rem;
}
.titCss{
  text-align: center;
  color: #ebebeb;
  font-size:0.2rem;
  padding-bottom: 0.5rem;
  h1{
    font-size:0.52rem;
  }
  p{
    color: #cccccc;
  }
}
.btn:hover {
  opacity:1!important;
  color: #fff;
  //transform: scale(1.05);
}
.animate-trigger {
  opacity: 0;
  transition: all 2s cubic-bezier(0.25, 0.1, 0.25, 1);
  will-change: opacity, transform;
  transition-delay: var(--delay, 0ms);/* 通过 data-delay 动态设置延迟时间 */
}
.animate-trigger.animate-active {// 动画激活状态（核心：定义结束状态）
  opacity: 1;
  transform: none !important;
}
.animate-trigger[data-animate="fadeInUp"] {
  transform: translateY(-80px); /* 初始向下偏移50px */
}
.enterprise-ai-container {
  width: 100%;
  min-height: 100vh;
  background:linear-gradient(to right, #0a0f2b, #46408a, #432a6d, #0a0f2b);
  color: #fff;
  font-family: 'Microsoft Yahei', sans-serif;
  overflow: hidden;
}
/* 顶部通知栏 */
.top-notice {
  background-color: #000;
  color: #fff;
  padding: 0.11rem 0;
  text-align: center;
  font-size:0.13rem;
}
/* 主内容区 */
.main-content {
  padding-top: 0.2rem;
  box-sizing: border-box;
  position: relative;
  text-align: center;
}
.topImg{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left-logo{
    width:0.7rem;
    height:0.8rem;
  }
  .right-github{
    width:0.35rem;
    height:0.35rem;
  }
  .more-service {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer; /* 鼠标悬停显示手型 */
    color: #515151; /* 文字颜色 */
    font-size: 0.14rem; /* 文字大小，根据需要调整 */
    margin-left:0.3rem;
    background: #fff;
    padding: 0.07rem 0.1rem;
    border-radius: 0.06rem;
  }

  /* 下拉框样式 */
  .service-dropdown {
    position: absolute; /* 相对于 .topImg 定位 */
    top:0.35rem; /* 位于按钮正下方 */
    left:-12%;
    min-width: 0.8rem; /* 下拉框宽度 */
    padding: 0.15rem;
    background: #fff;
    border-radius: 0.04rem;
    box-shadow: 0 0.02rem 0.1rem rgba(0,0,0,0.1); /* 阴影效果 */
    display: none; /* 默认隐藏 */
    z-index: 100; /* 确保在其他元素上方 */

    p {
      margin: 0 0 0.1rem 0;
      font-weight: bold;
      color: #666;
    }

    a {
      display: block; /* 每个链接占一行 */
      padding: 0.05rem 0;
      color: #333;
      text-decoration: none;

      &:hover {
        color: #3f2867; /* hover 颜色 */
      }
    }
  }

  /* 鼠标悬浮时显示下拉框 + 箭头旋转 */
  .more-service:hover .service-dropdown {
    display: block;
  }
}
.middle-tag {
  margin-top:1rem;
  background-color: rgb(74 55 135);
  box-shadow: 0.01rem 0.01rem 0.15rem rgb(101 66 167);
  color: #fff;
  border: 1px solid #7351ad;
  color: #fff;
  border-radius: 20px;
  padding:0.05rem 0.15rem;
  cursor: pointer;
  display: inline-block;
  font-size:0.17rem;
  span{
    color: #6a48bf;
  }
}
.title-desc {
  color: #ebebeb;
  .main-title {
    font-size:0.59rem;
    margin:0.2rem 0;
  }
  .main-desc {
    font-size:0.2rem;
    line-height:0.3rem;
  }
}
.function-btns {
  display: flex;
  justify-content: center;
  gap:0.2rem;
  margin-top:0.5rem;
  .btn {
    padding:0.09rem 0.16rem;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    opacity:0.8;
    font-size:0.18rem;
  }
  button{
    background-color: rgb(82, 64, 138);
    color: #ebebeb;
    display: flex;
    align-items: center;
  }
  img{
    width:0.25rem;
    height:0.25rem;
    margin-right: 0.1rem;
  }
  .ai-market {
    background-color: #fff;
    color: #000;
    span{
      color: #6a48bf;
      margin-left: 0.05rem;
    }
  }
}
.brandsDiv{
  background: #0f172a;
}
// 外层容器：限制显示宽度，隐藏溢出内容
.brands-container {
  width:100%;
  overflow: hidden; // 隐藏超出容器的部分
  box-sizing: border-box;
}

// 滚动轨道：用于执行动画
.brands-track {
  display: flex; // 让两个列表并排
  animation: scroll 20s linear infinite; // 20秒一轮，匀速，无限循环
}

// 品牌列表样式（复用你的原有样式，微调布局）
.cooperation-brands {
  display: flex;
  align-items: center;
  gap: 0.5rem; // 品牌间距
  cursor: pointer;

  //min-width: 100%; // 每个列表占满容器宽度，确保无缝衔接
  img {
    max-height:0.6rem;
    opacity: 0.8;
    transition: all 0.3s ease;
    &:hover {
      opacity: 1;
      transform: scale(1.1);
    }
  }
}
// 滚动动画：从右向左平移整个轨道（距离为一个列表的宽度）
@keyframes scroll {
  0% {
    transform: translateX(0); // 初始位置
  }
  100% {
    transform: translateX(-100%); // 平移一个列表的宽度
  }
}
.ai-platform-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color:#ebebeb;
}
.left-content {
  //max-width: 500px;
  .section-tag {
    font-size:0.18rem;
    color: #9d77ff;
  }
  .section-title {
    font-size:0.45rem;
    margin:0.2rem 0;
  }
  .section-desc {
    font-size:0.18rem;
    color: #c8c2e0;
    margin-bottom:0.4rem;
  }
  .ai-list {
    .ai-item {
      display: flex;
      align-items: center;
      padding:0.1rem 0.24rem;
      border: 1px solid #5b4a88;
      font-size:0.18rem;
      color: #c8c2e0;
      border-radius:0.11rem;
      margin-bottom:0.1rem;
      cursor: pointer;
      transition: all 0.3s ease;
      &.active {
        border-color: #9d77ff;
        background-color: rgba(157, 119, 255, 0.1);
        color: #fff;
      }
      .icon-feishu {
        width:0.23rem;
        height:0.23rem;
        background: url(@/assets/feis.png) no-repeat center;
        background-size: contain;
        margin-right:0.12rem;
      }
    }
    .ai-item:hover{
      border: solid #fff 1px;
      color: #fff;
    }
  }
}
.right-visual {
  position: relative;
  width:5rem;
  height: 5rem;
  .grid-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(@/assets/ai1.png) no-repeat center;
    background-size: cover;
    opacity: 0.6;
  }
  .ai-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: float 3s ease-in-out infinite;
    img {
      width:0.8rem;
      height:0.8rem;
      border-radius: 16px;
      //box-shadow: 0 0 40px rgba(157, 119, 255, 0.5);
    }
  }
}
@keyframes float {
  0% { transform: translate(-50%, -50%) translateY(0); }
  50% { transform: translate(-50%, -50%) translateY(-25px); }
  100% { transform: translate(-50%, -50%) translateY(0); }
}
.threeDiv{
  .threeText{
    color: #ebebeb;
    font-size:0.18rem;
    padding-bottom: 0.5rem;
    h3{
      font-size:0.23rem;
    }
    p{
      color: #cccccc;
    }
  }
  .tItem{
    display: flex;
    border: solid 1px rgba(255, 255, 255, 0.1);
    border-radius:0.3rem;
    padding:0.5rem;
    box-sizing: border-box;
    margin-bottom: 0.25rem;
    img{
      width:6rem;
      height:4.3rem;
    }
  }
  .threeTop{
    align-items: center;
    justify-content: space-between;
    background:linear-gradient(124deg, #46408a, #3c2664);
  }
  .threeBottom{
    display: flex;
    .threeItem{
      flex-direction: column;
      background:linear-gradient(5deg, #33225a, #2c1f52);
      width:49%;
      //align-items: center;
    }
    .threeItem:last-child img{
      margin: auto;
      width:2.5rem;
      height:2.5rem;
    }
    .threeItem:first-child img{
      width:5.46rem;
      margin: auto;
      height:2.5rem;
    }
  }
  .descDiv{
    margin:0.3rem 0;
    gap: 0.3rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    color: #cccccc;
    .descItem{
      font-size:0.15rem;
      line-height: 0.25rem;
      img{
        width:0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
      p{
        font-weight:600;
        font-size:0.2rem;
        color: #ebebeb;
        margin-bottom: 0.1rem;
      }
    }
  }
}
.fourDiv{
  text-align: center;
  img{
    margin: auto;
    width:10rem;
  }
}
.fiveDiv{
  .ai-feature-section {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }
  ::-webkit-scrollbar{width:0;}
  .feature-card {
    flex: 0 0 3rem;
    margin-right: 0.2rem;
    padding:0.24rem;
    border: solid 1px #5c556c;
    border-radius:0.23rem;
    color:#ebebeb;
    display: flex;
    flex-direction: column;
    scroll-snap-align: start;
    transition: all 1s cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  .feature-card:hover{
    cursor: pointer;
    background: #261c4b;
  }
  .card-icon {
    width:0.45rem;
    height:0.45rem;
  }

  .card-title {
    font-size:0.22rem;
    margin-bottom:0.08rem;
  }

  .card-desc {
    font-size:0.17rem;
    opacity: 0.8;
    margin-bottom:0.16rem;
    color: #cccccc;
    flex-grow: 1;
  }

  .card-link {
    font-size:0.14rem;
    color: #cccccc;
    text-decoration: none;
    align-self: flex-end;
    span{
      color: #a68ecd;
    }
  }

  .card-nav {
    display: flex;
    align-items: center;
    justify-content: end;
    margin-top:0.1rem;
  }

  .nav-btn {
    font-size:0.19rem;
    font-weight: 100;
    color:#fff;
    width:0.38rem;
    height:0.38rem;
    background-color: rgb(255, 255, 255, 0.1);
    border: none;
    border-radius:0.05rem;
    margin: 0 0.1rem;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .nav-btn:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
.sixDiv{
  background: linear-gradient(187deg, transparent, transparent, #0b102d 41%);
  .titCss{
    text-align: left;
  }
  .chat-feature-section {
    color:#ebebeb;
  }

  .section-group {
    //margin-bottom: 30px;
  }

  .section-title {
    font-size:0.18rem;
    color: #9370db;
    margin-bottom:0.16rem;
    font-weight: 600;
  }

  .feature-row {
    display: flex;
    flex-wrap: wrap;
    gap:0.2rem;
  }

  .feature-item {
    flex: 1;
    min-width: 3rem;
  }

  .item-title {
    font-size:0.18rem;
    margin-bottom:0.08rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    img{
      width:0.2rem;
      height:0.2rem;
      margin-right: 0.1rem;
    }
  }

  .item-desc {
    font-size:0.16rem;
    opacity: 0.8;
    line-height: 1.5;
  }

  .section-divider {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1);
    margin:0.3rem 0;
  }
}
.sevenDiv{
  .pricing-section {
    //border: solid 1px;
    color: #fff;
  }
  .toggle-group {
    color: #cac8e4;
    font-size:0.18rem;
    display: flex;
    align-items: center;
    margin-bottom:0.2rem;
    //justify-content: center;
    .toggle-switch {
      position: relative;
      display: inline-block;
      width:0.5rem;
      height:0.24rem;
      margin: 0 0.1rem;
    }
    .toggle-switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #93a2b7;
      transition: .4s;
      border-radius:0.4rem;
    }
    .slider:before {
      position: absolute;
      content: "";
      height:0.18rem;
      width:0.18rem;
      left:0.04rem;
      bottom:0.04rem;
      background-color: white;
      transition: .4s;
      border-radius: 50%;
    }
    input:checked + .slider {
      background-color: #9370db;
    }
    input:checked + .slider:before {
      transform: translateX(0.23rem);
    }
    .discount {
      //color: #9370db;
      //font-weight: bold;
    }
  }
  .pricing-grid {
    display: flex;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .rigDiv{
    box-shadow: 0px 0px 0.1rem 0px #3c3173;
    background: #3c3173;
  }
  .rigDiv:last-child{
    border-radius: 0 0.2rem 0.2rem 0;
  }
  .col {
    display: flex;
    flex-direction: column;
  }
  .plan-card {
    //background-color: rgba(255, 255, 255, 0.05);
    //border-radius:0.2rem;
    padding:0.2rem;
    text-align: center;
    //margin-bottom: 20px;
  }
  .sevenHead{
    border-bottom: solid 1px #43346a;
    height:2rem;
    text-align: left;

    .sevenText{
      font-size:0.17rem;
      margin: 0.16rem 0 0.24rem 0;
    }
    h3{
      color: #ad5ff6;
      font-size:0.21rem;
      font-weight: 400;
      margin: 0;
    }
  }
  .highlighted {
    border: 0.03rem solid #9370db;
    box-shadow: 0 0 0.22rem rgba(147, 112, 219, 0.3);
  }
  .sevenPri{
    display: flex;
    align-items: center;
  }
  .price {
    margin: 0.11rem 0;
    color: #aaa;
    font-size:0.16rem;
    span{
      font-size:0.3rem;
      font-weight: bold;
      color: #fff;
    }
  }
  .original-price {
    margin-left: 0.1rem;
    color: #aaa;
    text-decoration: line-through;
    font-size:0.16rem;
  }

  .member {
    font-size:0.16rem;
    color: #aaa;
    margin-bottom:0.22rem;
  }
  .deploy-btn {
    padding:0.1rem;
    border-radius:2rem;
    border: none;
    cursor: pointer;
    width: 100%;
    background-color: #9370db;
    color: #fff;
    font-size:0.18rem;
  }
  .gray {
    background-color: #dee0e2;
    color: #121111;
  }
  .feature-group {
    //background-color: rgba(255, 255, 255, 0.05);
    //border-radius: 8px;
    //padding: 20px;
    h4 {
      font-size:0.18rem;
      margin-bottom:0.11rem;
      font-weight: 400;
      color: #ebebeb;
      //border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      //padding-bottom: 8px;
      height:0.2rem;
      text-align: left;
    }

    ul {
      list-style: none;
      padding: 0;
      margin-bottom:0.15rem;
    }

    li {
      border-bottom: solid 1px #4e4483;
      height:0.25rem;
      padding:0.1rem 0;
      display: flex;
      font-size:0.17rem;
      color:#b5b5b5;
      justify-content: space-between;
    }
  }
}
.eight{
    background: linear-gradient(135deg, #0f172a 0%, #33225b 100%);
    color:#ebebeb;
    padding:0.82rem 0.22rem;
    text-align: center;
    position: relative;
    overflow: hidden;

  /* 背景渐变装饰（可选） */
  .eight::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 6.2rem;
    height: 6.2rem;
    background: radial-gradient(rgba(147, 112, 219, 0.2), transparent 70%);
    border-radius: 50%;
    transform: translateX(-50%);
    z-index: 0;
  }

  .hero-content {
    position: relative;
    z-index: 1;
    max-width: 800px;
    margin: 0 auto;
  }

  .tagline {
    font-size:0.17rem;
    color: #9370db;
    margin-bottom:0.17rem;
  }

  .title {
    font-size:0.45rem;
    font-weight: 700;
    margin-bottom:0.25rem;
    line-height: 1.2;
  }

  .desc {
    font-size:0.19rem;
    color:#cccccc;
    margin-bottom:0.35rem;
    line-height: 1.5;
  }

  .deploy-btn {
    padding:0.12rem 0.25rem;
    background-color: #fff;
    color: #0f172a;
    border: none;
    border-radius:0.35rem;
    font-size:0.17rem;
    //font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .deploy-btn:hover {
    background-color: #9370db;
    color: #fff;
  }

  .deploy-btn:hover::after {
    //content: '→';
    margin-left: 8px;
    color: #fff;
  }
}
.footeDiv{
  padding:0.15rem 3rem;
  background: #171934;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;

  p,a{
    font-size:0.17rem;
    color: #ccc;
    margin: 0 0.1rem;
  }
  .footText{
    text-align: center;
  }
}
</style>